export enum HotelEventPeriod {
  SUMMER = 'Summer',
  WINTER = 'Winter',
  NEW_YEAR = 'NewYear',
}
